import React from 'react';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import './ParticipantsSection.css';
import { useRecoilState } from 'recoil';
import { regularParticipantsIdState, teacherIdState } from '../../../state/participantAtom';
import { Close } from '../../Tray/Icons';
import ParticipantItem from './Components/ParticipantItem';

export default function ParticipantsSection({ showParticipants, toggleParticipants }) {
  const [regularParticipantsId] = useRecoilState(regularParticipantsIdState);
  const [teacherId] = useRecoilState(teacherIdState);
  const isTeacher = useLocalSessionId() === teacherId;
  const callObject = useDaily();

  const toggleAudio = (participantId, currentState) => {
    if (callObject) {
      const participantUpdate = {
        [participantId]: { setAudio: !currentState },
      };
      callObject.updateParticipants(participantUpdate);
    }
  };

  return showParticipants ? (
    <aside className="participant-list">
      <div className="participant-list-header">
        <p className="participant-list-title">Dalyviai ({regularParticipantsId.length})</p>
        <button onClick={toggleParticipants} className="close-participant-section" type="button">
          <Close />
        </button>
      </div>

      <ul className="participant-list-participants">
        {regularParticipantsId.length > 0 ? (
          regularParticipantsId.map((participantId) => (
            <li key={participantId} className="participant-list-item">
              <ParticipantItem
                participantId={participantId}
                isTeacher={isTeacher}
                toggleAudio={toggleAudio}
              />
              <hr className="participant-divider" />
            </li>
          ))
        ) : (
          <p className="no-participants">No participants available.</p>
        )}
      </ul>
    </aside>
  ) : null;
}
